export const defaultSections = [
  'stage',
  'usp',
  'exterior',
  'interior',
  'nba',
  'features',
  'techData',
  'offerTeaser',
] as const;

export type SectionName = (typeof defaultSections)[number];
export type SectionVisibility = Record<SectionName, boolean>;

export const sectionAnchorMap: Record<SectionName, string | undefined> = {
  stage: 'top',
  usp: 'highlights',
  exterior: 'exterior',
  interior: 'interior',
  nba: undefined,
  features: 'features',
  techData: 'tech-data',
  offerTeaser: 'shop-offers',
};

/// reverse mapping using Object.fromEntries
export const anchorSectionMap: Record<string, SectionName> = Object.fromEntries(
  Object.entries(sectionAnchorMap).map(([key, value]) => [value, key]),
);

// From the tracking specs the labels for each section should always be in snake_case and lowercase format
export const sectionTrackLabelMap: Record<SectionName, string> = {
  stage: 'stage',
  usp: 'highlights',
  exterior: 'exterior',
  interior: 'interior',
  nba: 'nba',
  features: 'features',
  techData: 'tech_data',
  offerTeaser: 'offer_teaser',
};
